<h2>XP. История начисления</h2>

<div class="container xp-history-content">
  <mat-card class="add-xp">
    <mat-card-subtitle>Начислить пользователю XP</mat-card-subtitle>
    <mat-card-content>
      <form class="add-xp-form" [formGroup]="addXpForm" (ngSubmit)="addXp()">

        <div class="inputs">
          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Кол-во</mat-label>
            <input matInput type="number" formControlName="amount" placeholder="кол-во">
          </mat-form-field>

          <mat-form-field class="form-field" appearance="outline">
            <mat-label>Комменатрий</mat-label>
            <input matInput type="text" formControlName="comment" placeholder="комментарий">
          </mat-form-field>
        </div>

        <button mat-stroked-button color="primary" [disabled]="addXpForm.invalid">Зачислить</button>
      </form>
    </mat-card-content>
  </mat-card>

  <div class="filter-container">
    <app-date-filter (dateFilter)="changeDateFilter($event)"></app-date-filter>
    <button mat-stroked-button color="warn" (click)="resetXpBonuses()">Сброс бонусов за XP</button>
  </div>
  <div class="xp-history-table-container">
    <div class="progress-bar" *ngIf="isLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <mat-table [dataSource]="userXpHistoryData" class="table xp-history-table" matSort #cashbackTableSort>

      <!-- count Column -->
      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef> #</mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index"> {{i + 1}}</mat-cell>
      </ng-container>

      <!-- type Column -->
      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Игра (тип)</mat-header-cell>
        <mat-cell *matCellDef="let element">{{logType[element.type]}}</mat-cell>
      </ng-container>

      <!-- timestamp Column -->
      <ng-container matColumnDef="timestamp">
        <mat-header-cell *matHeaderCellDef>Дата</mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.timestamp | date: 'dd.MM.yy HH:mm'}}</mat-cell>
      </ng-container>

      <!-- amount Column -->
      <ng-container matColumnDef="amount">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Кол-во (xp)</mat-header-cell>
        <mat-cell *matCellDef="let element"> +{{element.amount }} </mat-cell>
      </ng-container>

      <!-- merge Column -->
      <ng-container matColumnDef="merge">
        <mat-header-cell *matHeaderCellDef>Merge
          <mat-icon class="tip"
                    matTooltip="Мердж - группировка большой кучи записей в одну, обозначает кол-во опыта до даты мерджа в сумме"
                    matTooltipPosition="above"
          >info
          </mat-icon>
        </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.merge ? 'Да' : 'Нет' }} </mat-cell>
      </ng-container>


      <mat-header-row *matHeaderRowDef="userXpHistoryColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: userXpHistoryColumns;"></mat-row>

      <div class="empty-data" *matNoDataRow>
        <p>Данные отсутствуют</p>
      </div>
    </mat-table>
    <mat-paginator #paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
                   [pageSizeOptions]="pageSizeOptions" (page)="pageChanged($event)" aria-label="Select page">
    </mat-paginator>
  </div>
</div>

